import { useTranslation } from 'react-i18next';

import { Flex, Heading } from '@amzn/storm-ui';

import { CustomCard } from '../../../UiComponentsLibrary/CustomCard';
import CreateUser from '../CreateUser';
import EditUser from '../EditUser';
import UserManagementCardActions from '../UserManagementCardActions';
import ViewUser from '../ViewUser';
import MainContent from './components/MainContent';
import UserActionModalWrapper from './components/UserActionModalWrapper';
import { useUserManagement } from './hooks/useUserManagement';
import {
  CustomSnackbar,
  SnackbarVariants,
} from '../../../UiComponentsLibrary/CustomSnackbar';
import { USER_STATUS } from '../../constants/userStatus';

const UserManagement = () => {
  const { t } = useTranslation();
  const {
    editUserProps,
    viewUserProps,
    toOpenEditUser,
    createUserProps,
    deleteModalProps,
    mainContentProps,
    userManagementCardActionProps,
    snackbarProps,
  } = useUserManagement();

  return (
    <div id="user-management-container">
      <Heading id="user-management-header" size="medium">
        {t('user-management-header')}
      </Heading>
      {viewUserProps.isViewUser ? (
        <ViewUser {...viewUserProps} />
      ) : toOpenEditUser ? (
        <EditUser {...editUserProps} />
      ) : createUserProps.isCreateUser ? (
        <CreateUser
          onClose={() => createUserProps.setIsCreateUser(false)}
          customSnackbarMessage={snackbarProps.customSnackbarMessage}
          setCustomSnackbarMessage={snackbarProps.setCustomSnackbarMessage}
        />
      ) : (
        <CustomCard
          title={
            userManagementCardActionProps.showStatusUsers === USER_STATUS.ACTIVE
              ? t('active-users-card-title')
              : t('deleted-users-card-title')
          }
          actions={
            <Flex direction="row" columnGap="small">
              <UserManagementCardActions {...userManagementCardActionProps} />
            </Flex>
          }
        >
          <MainContent {...mainContentProps} />
        </CustomCard>
      )}
      <UserActionModalWrapper {...deleteModalProps} />

      {/* Custom Snackbar to display success message for any user management action*/}
      <CustomSnackbar
        id="custom-snackbar"
        variant={SnackbarVariants.SUCCESS}
        message={snackbarProps.customSnackbarMessage}
        isVisible={!!snackbarProps.customSnackbarMessage}
        onClose={() => snackbarProps.setCustomSnackbarMessage('')}
      />
    </div>
  );
};

export default UserManagement;
